//-tech-debt-react-query;
import { useQuery } from '@tanstack/react-query';
import { fetchItems } from '../support/queries';

export type SfTeamOpportunitiesFullResponse =
  | Record<string, { opportunities?: any[]; reports?: any }>
  | any;

export interface SfTeamOpportunitiesSummaryNode {
  email?: string;
  is_manager?: boolean;
  own_phase_counts?: Record<string, number>;
  own_total_opportunities?: number;
  phase_counts?: Record<string, number>;
  total_opportunities?: number;
  reports?: Record<string, SfTeamOpportunitiesSummaryNode>;
}

export interface SfTeamOpportunitiesSummaryResponse {
  manager_email: string;
  is_manager: boolean;
  view: 'summary';
  self: {
    phase_counts: Record<string, number>;
    total_opportunities: number;
    own_phase_counts: Record<string, number>;
    own_total_opportunities: number;
    is_manager: boolean;
  };
  reports: Record<string, SfTeamOpportunitiesSummaryNode>;
}

export type SfTeamOpportunitiesResponse =
  | SfTeamOpportunitiesFullResponse
  | SfTeamOpportunitiesSummaryResponse
  | any;

export interface UseSfTeamOpportunitiesOptions {
  enabled?: boolean;
  view?: 'full' | 'summary';
  [key: string]: any;
}

export function useSfTeamOpportunities(
  email: string | null | undefined,
  options?: UseSfTeamOpportunitiesOptions,
  /** `all` or `range:YYYY-MM-DD:YYYY-MM-DD` (inclusive close-date window). */
  timeFilter?: string,
) {
  const normalizedEmail = String(email || '').toLowerCase() || null;
  const view = options?.view || 'full';
  // The backend reads `current_time_filter` (it ignored the old `activity_time_filter` name here).
  const current_time_filter = timeFilter ?? 'all';

  const queryOptions = { ...(options || {}) };
  delete queryOptions.view;

  return useQuery({
    queryKey: ['SfTeamOpportunities', normalizedEmail, view, current_time_filter],
    queryFn: async () => {
      if (!normalizedEmail) return null;

      return fetchItems(
        'sf/team/opportunities',
        { email: normalizedEmail, view, current_time_filter },
        { includePageSize: false }
      );
    },
    ...{
        enabled: !!normalizedEmail && ((options?.enabled ?? true) as boolean),
        refetchOnWindowFocus: false,
        staleTime: 30_000,
        ...queryOptions,
      },
  });
}